import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorMessage: {
		id: 'servicedesk-request-details-panel.generic-error.error-message',
		defaultMessage: "We couldn't load these details. Try refreshing the page.",
		description: 'Error message to be displayed when there is an error fetching request details',
	},
});
